import { forwardRef, type InputHTMLAttributes } from "react";
import { twMerge } from "tailwind-merge";

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  invalid?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { className, invalid = false, ...props },
  ref
) {
  return (
    <input
      aria-invalid={invalid || undefined}
      className={twMerge(
        "min-h-11 w-full rounded-lg border border-line bg-surface px-3.5 py-2 text-body shadow-sm transition-[border-color,box-shadow,background-color] placeholder:text-muted/75 hover:border-accent/60 focus:border-accent focus:outline-none focus:ring-2 focus:ring-accent/20 disabled:cursor-not-allowed disabled:bg-line/30 disabled:opacity-70",
        invalid && "border-danger",
        className
      )}
      ref={ref}
      {...props}
    />
  );
});
